























import { AttachmentContent } from '@/resource/question/question.type';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';

@Component({
  components: {
    Modal,
    ComponentSubjective: () =>
      import(
        '@/components/questions/subjective-components/ComponentSubjective.vue'
      ),
  },
})
export default class SubjectiveAttachment extends Vue {
  @Prop({ required: true })
  content!: AttachmentContent;

  showModal = false;
  width = '1000px';
  title = 'Attachment';
  description = `here is the attachment for this question. It could be answer sheet, 
  cheat sheet, graphs or any material needed for student to answer the question. 
  The attachment will be attached at at the end of the pdf.`;

  toggleModal() {
    this.showModal = !this.showModal;
  }
}
